<template>
  <div class="outside-manners-card">
    <va-card title="Outside Manners">
      <outside-manners-classes />
      <h2 class="curriculum">
        Class curriculum
      </h2>
      <span class="class-description">
        In this 4 week class, you will take your training to the next level by practicing your recall, leash walking, and leave it and more in real world situations.
      </span>
      <va-accordion>
        <va-collapse customHeader>
          <span slot="header">
            <va-button :outline="true" :color="$themes.primary"
              :iconRight="`fa fa-angle-down va-collapse__header__icon`">
              Week 1 - The Foundations
            </va-button>
          </span>
          <div slot="body" class="week-description">
            <div>
              In Week 1 we will cover:
              <ol>
                <li>Introducing the marker</li>
                <li>Eye contact</li>
                <li>Name game</li>
                <li>Hand targeting</li>
                <li>Sit & Down</li>
                <li>Look at that</li>
              </ol>
            </div>
          </div>
        </va-collapse>
        <va-collapse customHeader>
          <span slot="header">
            <va-button :outline="true" :color="$themes.primary"
              :iconRight="`fa fa-angle-down va-collapse__header__icon`">
              Week 2 - Impulse Control
            </va-button>
          </span>
          <div slot="body" class="week-description">
            <div>
              In Week 2 we will cover:
              <ol>
                <li>How to use luring</li>
                <li>Loose leash walking intro</li>
                <li>Come</li>
                <li>Leave it</li>
                <li>Stay</li>
              </ol>
            </div>
          </div>
        </va-collapse>
        <va-collapse customHeader>
          <span slot="header">
            <va-button :outline="true" :color="$themes.primary"
              :iconRight="`fa fa-angle-down va-collapse__header__icon`">
              Week 3 - Adding distractions
            </va-button>
          </span>
          <div slot="body" class="week-description">
            <div>
              In Week 3 we will cover:
              <ol>
                <li>Leave it in more situations</li>
                <li>Coming when called</li>
                <li>Advanced leash walking</li>
                <li>Mat work</li>
              </ol>
            </div>
          </div>
        </va-collapse>
        <va-collapse customHeader>
          <span slot="header">
            <va-button :outline="true" :color="$themes.primary"
              :iconRight="`fa fa-angle-down va-collapse__header__icon`">
              Week 4 - Putting it all together
            </va-button>
          </span>
          <div slot="body" class="week-description">
            <div>
              In Week 4 we will cover:
              <ol>
                <li>Advanced coming when called</li>
                <li>Advanced leash walking</li>
                <li>Dog greetings</li>
                <li>Take it/Drop it</li>
                <li>Leave it on the go</li>
                <li>Tackling the obstacle course</li>
              </ol>
            </div>
          </div>
        </va-collapse>
      </va-accordion>
      <contact-group-class />
      <router-link :to="{name: 'all-group-classes'}" class="all-group-classes">
        <va-button>
          View all group classes
        </va-button>
      </router-link>
    </va-card>
  </div>
</template>

<script>
import OutsideMannersClasses from '../sub-components/OutsideMannersClasses'
import ContactGroupClass from '../sub-components/ContactGroupClass'

export default {
  name: 'outside-manners-card',
  components: {
    OutsideMannersClasses,
    ContactGroupClass,
  },
}
</script>

<style scoped lang="scss">
.outside-manners-card {
  .va-card__body {
    display: flex;
    flex-direction: column;
    align-items: center;

    .class-description {
      text-align: left;
      margin: 1rem;
    }

    .va-button {
      border-radius: 0.375rem;
      max-width: 90%;
      width: 90%;
      margin-left: 1rem;

      &__content {
        font-size: 1.3rem;
        font-family: Montserrat, sans-serif;

        &__title {
          font-size: 1.3rem;
        }
      }
    }

    .all-group-classes {
      display: flex;
      justify-content: center;
      margin-top: 1rem;

      .va-button {
        border-radius: 0.375rem;
        max-width: 90%;
        width: 90%;
        margin-left: 1rem;

        @include media-breakpoint-up(lg) {
          width: 50%;
        }

        &__content {
          font-size: 1.3rem;
          font-family: Montserrat, sans-serif;

          &__title {
            font-size: 1.3rem;
          }
        }
      }
    }

    .week-description {
      div {
        margin-top: 1rem;
      }

      ol {
        margin-left: 2rem;

        li {
          list-style: decimal;
        }
      }
    }

    span {
      margin-top: 1rem;
      text-align: center;
    }
  }

  .curriculum,
  .va-accordion {
    width: 100%;
  }
}
</style>
